import route from '../../constants/routes';
import { getRouteWithSlug } from '../../utils/common';

export const getArtistRoute = artistProfile => getRouteWithSlug(route.ARTISTS, artistProfile);

export const getProfileProfession = profile => {
  let primaryProfession = profile?.professions?.find(prof => prof?.isPrimary);
  primaryProfession = primaryProfession
    ? [primaryProfession?.profession?.qualification?.name ?? primaryProfession?.profession?.name]
    : undefined;
  const secProfessions = profile?.professions
    ?.filter(prof => !prof?.isPrimary)
    ?.reduce(
      (result, prof) =>
        prof?.profession?.qualification?.name
          ? [...result, prof?.profession?.qualification?.name]
          : [...result, prof?.profession?.name],
      [],
    );

  let profileProfession = [];

  if (primaryProfession?.length > 0) {
    profileProfession = primaryProfession;
  }

  if (secProfessions?.length > 0) {
    profileProfession.push(...secProfessions);
  }

  return profileProfession.join(', ');
};
